type TStorageEstimateWithDetails = StorageEstimate & { usageDetails?: Record<string, number> }

/**
 * `usageDetails` is a non-standard Chrome extension to StorageEstimate that splits usage by storage type
 * (caches, indexedDB, serviceWorkerRegistrations). Chrome reports `quota` as usage plus 10 GiB rather
 * than the real limit, so read `usage` and `usageDetails`.
 */
export const getStorageEstimate = async (): Promise<TStorageEstimateWithDetails | null> => {
  try {
    if (!navigator.storage?.estimate) return null

    return await navigator.storage.estimate()
  } catch {
    return null
  }
}
